import * as swcHelpers from '@swc/helpers';
import { LineItemModels } from '@grandvisionhq/lib-visuals';
import { getLocalizedString, isNil } from '@grandvisionhq/utils';
import '../utils/get-payment-status-label.js';
import { getPrices } from '../utils/get-prices.js';
import '@grandvisionhq/graphql';
import { toBaseLineItem } from './base-line-item.js';

function toLens(lens) {
    const { pupillaryDistance , prism , power , cylinder , axis , addition  } = lens;
    return swcHelpers.objectSpread({}, !isNil(pupillaryDistance) ? {
        pupillaryDistance
    } : null, !isNil(prism) ? {
        prism
    } : null, !isNil(power) ? {
        power
    } : null, !isNil(cylinder) ? {
        cylinder
    } : null, !isNil(axis) ? {
        axis
    } : null, !isNil(addition) ? {
        addition
    } : null);
}
function getPrescription(lineItem) {
    // PrescriptionGlasses line item will always have prescription
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const prescription = lineItem.prescription;
    switch(prescription.__typename){
        case 'AddedGlassesPrescription':
            return {
                type: LineItemModels.PrescriptionType.NEW_PRESCRIPTION,
                leftEye: toLens(prescription.leftLens),
                rightEye: toLens(prescription.rightLens)
            };
        case 'FilePrescription':
            return {
                type: LineItemModels.PrescriptionType.PRESCRIPTION_FILE,
                /**
         * TODO: YB - need to talk to BE about the FE needing a file name instead of a URL, and for
         * both prescription file and pupillary distance file.
         */ prescriptionFile: prescription.prescriptionFileName,
                pupillaryDistanceFile: prescription.pupillaryDistanceFileName
            };
        case 'EmailPrescription':
            return {
                type: LineItemModels.PrescriptionType.EMAIL_PRESCRIPTION
            };
        default:
            return {
                type: LineItemModels.PrescriptionType.EXISTING_CUSTOMER
            };
    }
}
const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.configurationDetails.filter((c)=>{
        if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle') {
            return c.configurationType === 'configurationbundle';
        }
        return true;
    }).map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>(child)=>({
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.configurationType}`),
            body: getLocalizedString(child.description, intl.locale),
            originalPrice: child.productPrice === child.totalPaid ? undefined : child.productPrice,
            price: child.totalPaid
        })
;
const toGlassesBundleOrderLineItem = (lineItem, intl, options = {})=>{
    var ref;
    const { originalPrice , discountPrice  } = getPrices(lineItem);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'GLASSES_BUNDLE',
        productType: 'prescription-glasses',
        prescription: getPrescription(lineItem),
        // lineItemOriginalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        originalPrice: originalPrice || 0,
        // lineItemDiscountedPrice is the price with the discount applied which we show next to the TOTAL PRICE for the entire bundle, including child line items
        discountPrice: discountPrice || 0,
        subProductType: ((ref = lineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.type) || '',
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};
const toGlassesBundleNonPrescriptionOrderLineItem = (lineItem, intl, options = {})=>{
    const { originalPrice , discountPrice  } = getPrices(lineItem);
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'NON_PRESCRIPTION_BUNDLE',
        productType: 'non-prescription-bundle',
        // lineItemOriginalPrice is the price we show as TOTAL PRICE for the entire bundle, including child line items
        originalPrice: originalPrice || 0,
        // lineItemDiscountedPrice is the price with the discount applied which we show next to the TOTAL PRICE for the entire bundle, including child line items
        discountPrice,
        bundleChildLineItems: mapBundleChildLineItems(lineItem, intl)
    });
};

export { toGlassesBundleNonPrescriptionOrderLineItem, toGlassesBundleOrderLineItem };
//# sourceMappingURL=glasses-bundle-line-item.js.map
